import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=72aab9e5&scoped=true"
import script from "./editAnnouncement.vue?vue&type=script&lang=js"
export * from "./editAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./editAnnouncement.vue?vue&type=style&index=0&id=72aab9e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aab9e5",
  null
  
)

export default component.exports